// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_catalogos.proto (package sextante.plataforma.catalogos.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_catalogos.proto.
 */
export const file_plataforma_catalogos: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Los catalogos no reciben parametros: siempre la lista completa.
 *
 * @generated from message sextante.plataforma.catalogos.v1.CatalogoPlataformaRequest
 */
export type CatalogoPlataformaRequest = Message<"sextante.plataforma.catalogos.v1.CatalogoPlataformaRequest"> & {
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.CatalogoPlataformaRequest.
 * Use `create(CatalogoPlataformaRequestSchema)` to create a new message.
 */
export const CatalogoPlataformaRequestSchema: GenMessage<CatalogoPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 0);

/**
 * Departamento.
 *
 * @generated from message sextante.plataforma.catalogos.v1.DepartamentoPlataformaItem
 */
export type DepartamentoPlataformaItem = Message<"sextante.plataforma.catalogos.v1.DepartamentoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.DepartamentoPlataformaItem.
 * Use `create(DepartamentoPlataformaItemSchema)` to create a new message.
 */
export const DepartamentoPlataformaItemSchema: GenMessage<DepartamentoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 1);

/**
 * Departamentos, por nombre.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListDepartamentosPlataformaResponse
 */
export type ListDepartamentosPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListDepartamentosPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.DepartamentoPlataformaItem items = 1;
   */
  items: DepartamentoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListDepartamentosPlataformaResponse.
 * Use `create(ListDepartamentosPlataformaResponseSchema)` to create a new message.
 */
export const ListDepartamentosPlataformaResponseSchema: GenMessage<ListDepartamentosPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 2);

/**
 * Municipio con su departamento.
 *
 * @generated from message sextante.plataforma.catalogos.v1.MunicipioPlataformaItem
 */
export type MunicipioPlataformaItem = Message<"sextante.plataforma.catalogos.v1.MunicipioPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string departamento_id = 2;
   */
  departamentoId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.MunicipioPlataformaItem.
 * Use `create(MunicipioPlataformaItemSchema)` to create a new message.
 */
export const MunicipioPlataformaItemSchema: GenMessage<MunicipioPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 3);

/**
 * Municipios, por nombre.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListMunicipiosPlataformaResponse
 */
export type ListMunicipiosPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListMunicipiosPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.MunicipioPlataformaItem items = 1;
   */
  items: MunicipioPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListMunicipiosPlataformaResponse.
 * Use `create(ListMunicipiosPlataformaResponseSchema)` to create a new message.
 */
export const ListMunicipiosPlataformaResponseSchema: GenMessage<ListMunicipiosPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 4);

/**
 * Region de un departamento.
 *
 * @generated from message sextante.plataforma.catalogos.v1.RegionPlataformaItem
 */
export type RegionPlataformaItem = Message<"sextante.plataforma.catalogos.v1.RegionPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string departamento_id = 2;
   */
  departamentoId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.RegionPlataformaItem.
 * Use `create(RegionPlataformaItemSchema)` to create a new message.
 */
export const RegionPlataformaItemSchema: GenMessage<RegionPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 5);

/**
 * Regiones, por nombre.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListRegionesPlataformaResponse
 */
export type ListRegionesPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListRegionesPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.RegionPlataformaItem items = 1;
   */
  items: RegionPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListRegionesPlataformaResponse.
 * Use `create(ListRegionesPlataformaResponseSchema)` to create a new message.
 */
export const ListRegionesPlataformaResponseSchema: GenMessage<ListRegionesPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 6);

/**
 * Solo lo que pinta la pagina Cultivos: nombre y tipo de monitoreo como flags.
 *
 * @generated from message sextante.plataforma.catalogos.v1.CultivoCatalogoPlataformaItem
 */
export type CultivoCatalogoPlataformaItem = Message<"sextante.plataforma.catalogos.v1.CultivoCatalogoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * El cultivo no tiene monitoreo de plagas.
   *
   * @generated from field: bool is_sin_monitoreo = 3;
   */
  isSinMonitoreo: boolean;

  /**
   * @generated from field: bool is_monitoreo_cafe = 4;
   */
  isMonitoreoCafe: boolean;

  /**
   * @generated from field: bool is_monitoreo_citricos = 5;
   */
  isMonitoreoCitricos: boolean;

  /**
   * @generated from field: bool is_monitoreo_aguacate_hass = 6;
   */
  isMonitoreoAguacateHass: boolean;

  /**
   * @generated from field: bool is_monitoreo_mango = 7;
   */
  isMonitoreoMango: boolean;

  /**
   * @generated from field: bool is_monitoreo_macadamia = 8;
   */
  isMonitoreoMacadamia: boolean;

  /**
   * @generated from field: bool is_monitoreo_guanabana = 9;
   */
  isMonitoreoGuanabana: boolean;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.CultivoCatalogoPlataformaItem.
 * Use `create(CultivoCatalogoPlataformaItemSchema)` to create a new message.
 */
export const CultivoCatalogoPlataformaItemSchema: GenMessage<CultivoCatalogoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 7);

/**
 * Cultivos, por nombre.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListCultivosCatalogoPlataformaResponse
 */
export type ListCultivosCatalogoPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListCultivosCatalogoPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.CultivoCatalogoPlataformaItem items = 1;
   */
  items: CultivoCatalogoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListCultivosCatalogoPlataformaResponse.
 * Use `create(ListCultivosCatalogoPlataformaResponseSchema)` to create a new message.
 */
export const ListCultivosCatalogoPlataformaResponseSchema: GenMessage<ListCultivosCatalogoPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 8);

/**
 * Producto agroquimico.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ProductoCatalogoPlataformaItem
 */
export type ProductoCatalogoPlataformaItem = Message<"sextante.plataforma.catalogos.v1.ProductoCatalogoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Registro del producto ante la autoridad.
   *
   * @generated from field: string numero_registro = 2;
   */
  numeroRegistro: string;

  /**
   * @generated from field: string categoria = 3;
   */
  categoria: string;

  /**
   * @generated from field: string tipo = 4;
   */
  tipo: string;

  /**
   * @generated from field: string descripcion = 5;
   */
  descripcion: string;

  /**
   * @generated from field: string unidad_medida = 6;
   */
  unidadMedida: string;

  /**
   * @generated from field: string tipo_formulacion = 7;
   */
  tipoFormulacion: string;

  /**
   * @generated from field: string empresa = 8;
   */
  empresa: string;

  /**
   * @generated from field: string ingrediente_activo = 9;
   */
  ingredienteActivo: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ProductoCatalogoPlataformaItem.
 * Use `create(ProductoCatalogoPlataformaItemSchema)` to create a new message.
 */
export const ProductoCatalogoPlataformaItemSchema: GenMessage<ProductoCatalogoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 9);

/**
 * Productos, por descripcion.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListProductosCatalogoPlataformaResponse
 */
export type ListProductosCatalogoPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListProductosCatalogoPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.ProductoCatalogoPlataformaItem items = 1;
   */
  items: ProductoCatalogoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListProductosCatalogoPlataformaResponse.
 * Use `create(ListProductosCatalogoPlataformaResponseSchema)` to create a new message.
 */
export const ListProductosCatalogoPlataformaResponseSchema: GenMessage<ListProductosCatalogoPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 10);

/**
 * Plaga o enfermedad de monitoreo, con sus umbrales.
 *
 * @generated from message sextante.plataforma.catalogos.v1.PlagaCatalogoPlataformaItem
 */
export type PlagaCatalogoPlataformaItem = Message<"sextante.plataforma.catalogos.v1.PlagaCatalogoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Tipo de monitoreo al que pertenece, como Cafe o Citricos.
   *
   * @generated from field: string tipo_monitoreo = 2;
   */
  tipoMonitoreo: string;

  /**
   * @generated from field: string grupo = 3;
   */
  grupo: string;

  /**
   * @generated from field: int32 orden = 4;
   */
  orden: number;

  /**
   * @generated from field: string nombre_comun = 5;
   */
  nombreComun: string;

  /**
   * @generated from field: string nombre_tecnico = 6;
   */
  nombreTecnico: string;

  /**
   * Umbral de precaucion de la incidencia. 0 = sin umbral.
   *
   * @generated from field: int32 rango_bajo = 7;
   */
  rangoBajo: number;

  /**
   * Umbral de alerta de la incidencia. 0 = sin umbral.
   *
   * @generated from field: int32 rango_medio = 8;
   */
  rangoMedio: number;

  /**
   * Plaga critica: cualquier deteccion es alerta.
   *
   * @generated from field: bool is_critico = 9;
   */
  isCritico: boolean;

  /**
   * Texto libre sobre la logica del umbral.
   *
   * @generated from field: string logica_umbral = 10;
   */
  logicaUmbral: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.PlagaCatalogoPlataformaItem.
 * Use `create(PlagaCatalogoPlataformaItemSchema)` to create a new message.
 */
export const PlagaCatalogoPlataformaItemSchema: GenMessage<PlagaCatalogoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 11);

/**
 * Plagas y enfermedades, por grupo y orden.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListPlagasCatalogoPlataformaResponse
 */
export type ListPlagasCatalogoPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListPlagasCatalogoPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.PlagaCatalogoPlataformaItem items = 1;
   */
  items: PlagaCatalogoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListPlagasCatalogoPlataformaResponse.
 * Use `create(ListPlagasCatalogoPlataformaResponseSchema)` to create a new message.
 */
export const ListPlagasCatalogoPlataformaResponseSchema: GenMessage<ListPlagasCatalogoPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 12);

/**
 * Estado fenologico del cultivo que registra el monitor.
 *
 * @generated from message sextante.plataforma.catalogos.v1.EstadoFenologicoPlataformaItem
 */
export type EstadoFenologicoPlataformaItem = Message<"sextante.plataforma.catalogos.v1.EstadoFenologicoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 orden = 2;
   */
  orden: number;

  /**
   * @generated from field: string codigo = 3;
   */
  codigo: string;

  /**
   * @generated from field: string descripcion = 4;
   */
  descripcion: string;
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.EstadoFenologicoPlataformaItem.
 * Use `create(EstadoFenologicoPlataformaItemSchema)` to create a new message.
 */
export const EstadoFenologicoPlataformaItemSchema: GenMessage<EstadoFenologicoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 13);

/**
 * Estados fenologicos, por orden.
 *
 * @generated from message sextante.plataforma.catalogos.v1.ListEstadosFenologicosPlataformaResponse
 */
export type ListEstadosFenologicosPlataformaResponse = Message<"sextante.plataforma.catalogos.v1.ListEstadosFenologicosPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.catalogos.v1.EstadoFenologicoPlataformaItem items = 1;
   */
  items: EstadoFenologicoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.catalogos.v1.ListEstadosFenologicosPlataformaResponse.
 * Use `create(ListEstadosFenologicosPlataformaResponseSchema)` to create a new message.
 */
export const ListEstadosFenologicosPlataformaResponseSchema: GenMessage<ListEstadosFenologicosPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_catalogos, 14);

/**
 * Catalogos de solo lectura de la app Plataforma (migracion a gRPC-Web, ver CLAUDE.md): geograficos
 * (form de finca y Pipeline), cultivos y productos (menus Cultivos/Productos) y monitoreo (menu
 * Monitoreo). Independiente de los catalogos gRPC de Cliente: solo los campos que usa Plataforma, sin
 * delta. Todos devuelven solo registros no eliminados, ya ordenados. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.catalogos.v1.CatalogosPlataformaService
 */
export const CatalogosPlataformaService: GenService<{
  /**
   * Departamentos, por nombre.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListDepartamentos
   */
  listDepartamentos: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListDepartamentosPlataformaResponseSchema;
  },
  /**
   * Municipios (con su departamento), por nombre.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListMunicipios
   */
  listMunicipios: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListMunicipiosPlataformaResponseSchema;
  },
  /**
   * Regiones de departamento (con su departamento), por nombre.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListRegiones
   */
  listRegiones: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListRegionesPlataformaResponseSchema;
  },
  /**
   * Cultivos con su tipo de monitoreo (como flags), por nombre.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListCultivos
   */
  listCultivos: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListCultivosCatalogoPlataformaResponseSchema;
  },
  /**
   * Productos agroquimicos, por descripcion.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListProductos
   */
  listProductos: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListProductosCatalogoPlataformaResponseSchema;
  },
  /**
   * Plagas y enfermedades de monitoreo, por grupo y orden.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListPlagas
   */
  listPlagas: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListPlagasCatalogoPlataformaResponseSchema;
  },
  /**
   * Estados fenologicos, por orden.
   *
   * @generated from rpc sextante.plataforma.catalogos.v1.CatalogosPlataformaService.ListEstadosFenologicos
   */
  listEstadosFenologicos: {
    methodKind: "unary";
    input: typeof CatalogoPlataformaRequestSchema;
    output: typeof ListEstadosFenologicosPlataformaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_catalogos, 0);

